import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'help-menu',
  templateUrl: './help-menu.component.html',
  styleUrls: ['./help-menu.component.css']
})
export class HelpMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
